import { styled } from '@material-ui/core';

export const AlertContainer = styled('div')({
  padding: '16px 24px',
});

export const AlertTitle = styled('div')(({ theme }) => ({
  color: theme.palette.common.black,
  fontSize: '16px',
  fontWeight: 'bold',
  marginBottom: '16px',
}));

export const AlertContent = styled('div')(({ theme }) => ({
  color: theme.palette.common.lightText,
  marginBottom: '16px',
}));

export const AlertFooter = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
});
